// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomTakeBackBody = {
  poolId: string;
  awardGrantId: string;
};

export type typeAwardCustomTakeBackOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isRevoked: boolean };
};

export type typeAwardCustomTakeBackOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomTakeBackOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomTakeBackOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomTakeBackBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardGrantId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "awardGrantId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomTakeBack(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomTakeBackBody);
  }

  return async function postAwardCustomTakeBack(
    payload: typeAwardCustomTakeBackBody,
  ): Promise<
    typeAwardCustomTakeBackOutput200 | typeAwardCustomTakeBackOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomTakeBack" failed before calling the network. #e3636350a849`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e3636350a849" },
        },
        data: null,
      } as typeAwardCustomTakeBackOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-take-back`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomTakeBackOutput200 | typeAwardCustomTakeBackOutput400;
  };
}
